/* TimeLab: media slideshow (closing bands, home story, home apparel) with the home hero's feel:
   slides crossfade with a slow zoom; videos autoplay muted inline and only the visible one plays.
   window.tleBandScan() re-scans (used when the theme editor re-renders a section). */
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var slides = [].slice.call(root.querySelectorAll('[data-tle-band-slide]'));
    if (!slides.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = Number(root.dataset.speed) || 6000, active = 0, timer = null, visible = false;
    function show(i) {
      slides.forEach(function (s, k) {
        var v = s.querySelector('video');
        if (k === i) { s.classList.add('is-active'); if (v && visible) { try { v.currentTime = 0; } catch (e) {} var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
        else { s.classList.remove('is-active'); if (v) v.pause(); }
      });
    }
    function next() { if (!root.isConnected) { stop(); return; } active = (active + 1) % slides.length; show(active); }
    function start() { if (timer || slides.length < 2 || reduce) return; timer = setInterval(next, speed); }
    function stop() { clearInterval(timer); timer = null; }
    show(0);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          visible = e.isIntersecting;
          var v = slides[active].querySelector('video');
          if (visible) { if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } start(); }
          else { if (v) v.pause(); stop(); }
        });
      }, { threshold: .15 }).observe(root);
    } else { visible = true; show(0); start(); }
  }
  function scan(r) { (r || document).querySelectorAll('[data-tle-band-videos]').forEach(init); }
  window.tleBandScan = scan;
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { scan(); }); } else { scan(); }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();